/**
 * Factory für {@link EngineResult}. Wird von praktisch jeder Engine im Monorepo
 * konsumiert — Signatur und Rückgabe-Form sind bewusst stabil zu halten.
 *
 * Verhalten von `confidenceScore`:
 * 1. **Default:** Ist `opts.confidenceScore` nicht gesetzt, wird `1.0` für `status === "success"`
 *    verwendet, andernfalls `0.0` (unveränderte historische Semantik).
 * 2. **Clamping:** Der resultierende Wert (Default *oder* explizit übergeben) wird hart auf
 *    **[0, 1]** beschränkt: `Math.max(0, Math.min(1, score))`. Werte > 1 → 1, Werte < 0 → 0,
 *    Werte innerhalb des Bereichs bleiben unverändert. Dies ist eine immer-sichere Invariante;
 *    sie ändert keinen gültigen Bestandswert.
 *
 * Die Status→Konfidenz-Bänder sind in {@link EngineStatus} dokumentiert. Diese Factory
 * verändert KEINE Defaults pro Status über die obige Regel hinaus.
 *
 * @typeParam T - Nutzdaten-Typ.
 * @param status - {@link EngineStatus} der Ausgabe.
 * @param data   - Nutzdaten oder `null` (z. B. bei `failed`).
 * @param opts   - Optionale Felder; `confidenceScore` wird auf [0,1] geklemmt.
 * @returns Ein vollständig befülltes {@link EngineResult} mit garantiertem `confidenceScore ∈ [0,1]`.
 */
export function createEngineResult(status, data, opts = {}) {
    const rawConfidence = opts.confidenceScore ?? (status === "success" ? 1.0 : 0.0);
    // Immer-sichere Invariante: confidenceScore ist auf [0, 1] beschränkt.
    const confidenceScore = Math.max(0, Math.min(1, rawConfidence));
    return {
        status,
        data,
        warnings: opts.warnings ?? [],
        errors: opts.errors ?? [],
        assumptions: opts.assumptions ?? [],
        confidenceScore,
        sourceRefs: opts.sourceRefs ?? [],
        createdAt: new Date().toISOString(),
        version: "0.1.0",
    };
}
//# sourceMappingURL=engine-result.js.map